import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

// const clientId =
// 	'1069104887945-ci21eisdflinikhpi93q151p1a3jbej2.apps.googleusercontent.com';

const theme = extendTheme({
	colors: {
		brand: {
			50: '#f0e4ff',
			100: '#cbb2ff',
			200: '#a480ff',
			300: '#7a4dff',
			400: '#641bfe',
			500: '#5a01e5',
			600: '#5200b3',
			700: '#430081',
			800: '#2d004f',
			900: '#14001f',
		},
	},
	fonts: {
		heading: `'Inter', sans-serif`,
		body: `'Inter', sans-serif`,
	},
	initialColorMode: 'dark',
	useSystemColorMode: false,
});
// const config = {
// 	initialColorMode: 'light',
// 	useSystemColorMode: false,
// };

// const theme = extendTheme({ config });
root.render(
	<React.StrictMode>
		{/* <GoogleOAuthProvider clientId={clientId}> */}
		<ChakraProvider theme={theme}>
			<App />
		</ChakraProvider>
		{/* </GoogleOAuthProvider> */}
	</React.StrictMode>
);
